<template>
  <v-card v-if="loading" height="500" >
    <v-card-text class="flex align-center">
      <div class="flex justify-center">
      <v-progress-circular
          class="align-content-center align-center justify-center"
          indeterminate
          color="primary"
          size="40"
      />
      </div>
    </v-card-text>
  </v-card>
  <v-card v-else>
    <v-card-title class="d-flex justify-space-between"
    >
      <div>{{ dialogTitle }}</div>
      <v-btn fab text small @click="handleClose" right
      >
        <v-icon>close</v-icon>
      </v-btn
      >
    </v-card-title>

    <v-card-text>

      <v-form ref="addSpeakerForm" v-model="isFormValid">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-row dense>
              <v-col cols="12" class="d-flex justify-center mb-3">
                <vue-dropzone
                    v-if="currentSpeaker.displayImageURL == ''"
                    ref="speakersImageDropzone"
                    id="speakersImageDropzone"
                    :options="dropzoneOptions"
                    @vdropzone-file-added="fileAdded"
                    v-el:mybtn
                    :useCustomSlot="true"
                    class="fab rounded-circle circular-dropzone-border d-flex flex-column justify-center align-center cursor-pointer text-center"
                    style="width: 155px; height: 155px"
                    v-ripple="{ center: true, class: 'rounded-circle' }"
                >
                  <div>
                    <v-icon>mdi-image-outline</v-icon>
                  </div>
                  <div class="font-weight-bold">
                    Upload speaker <br/>profile photo
                  </div>
                </vue-dropzone>
                <div v-else class="d-flex align-center fab circle">
                  <div class="d-flex align-center">
                    <v-card class="mr-2 pa-0 outlined-border circle">
                      <v-img
                          :aspect-ratio="1"
                          height="155"
                          width="155"
                          :src="currentSpeaker.displayImageURL"
                      >
                      </v-img>
                    </v-card>
                    <div class="text-center mr-2 mt-2">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-avatar
                              color="white"
                              class="elevation-5 d-block mb-2"
                              size="25"
                              v-bind="attrs"
                              v-on="on"
                              @click="updateLogo"
                          >
                            <v-icon small>mdi-image</v-icon>
                          </v-avatar>
                        </template>
                        <span>
                          Change image
                        </span>
                      </v-tooltip>
                      <AvatarButton
                          icon="mdi-trash-can"
                          tooltipText="Delete logo"
                          className="d-inline-block mr-2"
                          @click="handleDeleteLogo"
                      />
                    </div>
                  </div>
                </div>
                <div
                    class="error--text"
                    v-if="showDisplayImageURLValidationError"
                >
                  Sponsor's profile photo is required
                </div>
              </v-col>
              <v-col cols="6" class="pb-0">
                <v-text-field
                    dense
                    outlined
                    :rules="requiredRules"
                    label="First name"
                    placeholder="First name"
                    v-model="currentSpeaker.firstName"
                />
              </v-col>
              <v-col cols="6" class="pb-0">
                <v-text-field
                    dense
                    outlined
                    :rules="requiredRules"
                    label="Last name"
                    placeholder="Last name"
                    v-model="currentSpeaker.lastName"
                />
              </v-col>
              <!-- <v-col cols="12" class="pb-0"
                ><v-text-field
                  dense
                  outlined
                  :rules="requiredRules"
                  label="Email"
                  hint="Email is for admin purposes only, it will not appear in the app."
                  placeholder="Email"
                  v-model="currentSpeaker.email"
              /></v-col> -->
              <v-col cols="12" class="pb-0"
              >
                <v-text-field
                    dense
                    outlined
                    :rules="requiredRules"
                    label="Job Title/Role"
                    placeholder="Job Title/Role"
                    v-model="currentSpeaker.jobTitle"
                />
              </v-col>
              <v-col cols="12" class="pb-0"
              >
                <v-text-field
                    dense
                    outlined
                    :rules="requiredRules"
                    label="Company"
                    placeholder="Company"
                    v-model="currentSpeaker.businessName"
                />
              </v-col>
              <v-col cols="12" class="pb-0"
              >
                <v-text-field
                    dense
                    outlined
                    :rules="requiredRules"
                    label="Email"
                    placeholder="Email"
                    v-model="currentSpeaker.email"
                />
              </v-col>
              <v-col cols="12" class="pb-0"
              >
                <v-textarea

                    dense
                    outlined
                    :rules="requiredRules"
                    label="Bio"
                    placeholder="Bio"
                    v-model="currentSpeaker.bio"
                />
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>

            <v-card-subtitle class="text-h6 font-weight-regular">Speaker's Social <span class="grey--text text-body-1">(Optional)</span>
            </v-card-subtitle>
            <v-row>
              <v-col cols="12">
                <SocialTextFields :show-title="false" title="Facebook" icon="facebook-icon.svg" label="Facebook"
                                  :value="currentSpeaker.facebook" :url-prefix="urlPrefixes.facebookUrlPrefix"
                                  @input="currentSpeaker.facebook=$event" :required-rules="requiredSocialRules"
                />
                <SocialTextFields title="Instagram" icon="instagram-icon.svg"
                                  label="Instagram" :value="currentSpeaker.instagram"
                                  :url-prefix="urlPrefixes.instagramUrlPrefix" :show-title="false"
                                  @input="currentSpeaker.instagram=$event"
                                  :required-rules="requiredSocialRules"
                />
                <SocialTextFields title="Twitter" icon="twitter-icon.svg" label="Twitter"
                                  :value="currentSpeaker.twitter" :url-prefix="urlPrefixes.twitterUrlPrefix"
                                  :show-title="false"
                                  @input="currentSpeaker.twitter=$event"
                                  :required-rules="requiredSocialRules"
                />
                <SocialTextFields title="LinkedIn" icon="linkedin-icon.svg" label="LinkedIn"
                                  :value="currentSpeaker.linkedin" :url-prefix="urlPrefixes.linkedinUrlPrefix"
                                  :show-title="false"
                                  @input="currentSpeaker.linkedin=$event"
                                  :required-rules="requiredSocialRules"
                />
                <SocialTextFields title="YouTube" icon="youtube-icon.svg" label="YouTube"
                                  :value="currentSpeaker.youtube" :url-prefix="urlPrefixes.youtubeurlPrefix"
                                  :show-title="false"
                                  @input="currentSpeaker.youtube=$event"
                                  :required-rules="requiredSocialRules"
                />
                <SocialTextFields title="Podcast" icon="podcast-icon.svg" label="Podcast"
                                  :value="currentSpeaker.podcast" :url-prefix="urlPrefixes.urlPrefix"
                                  :show-title="false"
                                  @input="currentSpeaker.podcast=$event"
                                  :required-rules="requiredSocialRules"
                />
              </v-col>
            </v-row>

          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" cla>
                <ImageCropper
                    :selectedImage="selectedImage"
                    @uploaded="handleUploaded"
                    previewType="displayImageURL"
                    :key="refreshCropper"
                />
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-col cols="4">
        <v-btn v-if="tab == 1" class="primary text-right" depressed large block :disabled="!isButtonEnabled"
               width="150"
               @click="handleAddSpeaker(true)">Done and add another
        </v-btn>

      </v-col>
      <v-col cols="4">
        <v-btn v-if="tab != 2" class="primary text-right" depressed large block :disabled="!isButtonEnabled"
               width="150"
               @click="handleAddSpeaker(false)">{{ saveSpeakerBtnText }}
        </v-btn>
      </v-col>
      <div>
        <v-col cols="12" offset="8">
          <v-row>

          </v-row>
        </v-col>
      </div>
      <!--      <v-col cols="4" offset="8" class="text-right"
            >
              <v-btn
                  v-if="tab == 0"
                  depressed
                  class="primary"
                  large
                  width="150"
                  :disabled="!isSaveSpeakerEnabled"
                  @click="handleAddSpeaker"
              >{{ saveSpeakerBtnText }}
              </v-btn
              >
            </v-col
            >-->
    </v-card-actions>
  </v-card>
</template>
<script>
import AvatarButton from "@/components/AvatarButton"
import ImageCropper from "@/components/ImageCropper"
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import {mapGetters} from "vuex";
import vue2Dropzone from "vue2-dropzone";
import urlPrefixes from "@/store/modules/urlPrefixes";
import SocialTextFields from "@/components/MultiConnect/Sponsors/SocialTextFields.vue";
import Speaker from "@/models/Speaker";
import Attendee from "@/models/Attendee";

const uuid = require("uuid");

export default {
  name: 'AddSpeakerDialog',
  components: {AvatarButton, ImageCropper, vueDropzone: vue2Dropzone, SocialTextFields},
  watch: {
    "currentSpeaker.facebook": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.facebookUrlPrefix)) {
        this.currentSpeaker.facebook = this.currentSpeaker.facebook.replace(
            this.urlPrefixes.facebookUrlPrefix,
            ""
        );
      }
    },
    "currentSpeaker.instagram": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.instagramUrlPrefix)) {
        this.currentSpeaker.instagram = this.currentSpeaker.instagram.replace(
            this.urlPrefixes.instagramUrlPrefix,
            ""
        );
      }
    },
    "currentSpeaker.twitter": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.twitterUrlPrefix)) {
        this.currentSpeaker.twitter = this.currentSpeaker.twitter.replace(
            this.urlPrefixes.twitterUrlPrefix,
            ""
        );
      }
    },
    "currentSpeaker.linkedin": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.linkedinUrlPrefix)) {
        this.currentSpeaker.linkedin = this.currentSpeaker.linkedin.replace(
            this.urlPrefixes.linkedinUrlPrefix,
            ""
        );
      }
    },
    "currentSpeaker.website": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.urlPrefix)) {
        this.currentSpeaker.website = this.currentSpeaker.website.replace(this.urlPrefixes.urlPrefix, "");
      }
    },
    "currentSpeaker.podcast": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.urlPrefix)) {
        this.currentSpeaker.podcast = this.currentSpeaker.podcast.replace(this.urlPrefixes.urlPrefix, "");
      }
    },
  },
  methods: {
    async fileAdded(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = async (event) => {
        //event.target.result - is dataURL datas
        let base64String = event.target.result;
        this.selectedImage = base64String;
        this.tab = 2;
        this.refreshCropper = 1;
      };
    },
    handleUploaded(downloadURL, logoFrame) {
      this.currentSpeaker.displayImageURL = downloadURL;
      this.refreshCropper = 0;
      this.tab = 0;
    },
    updateLogo() {
      this.handleDeleteLogo();
      this.$nextTick(function() {
        this.$refs.speakersImageDropzone.$el.click();
      }.bind(this));
    },
    handleDeleteLogo() {
      this.currentSpeaker.displayImageURL = "";
      this.refreshCropper = 0;
    },
    handleClose() {
      this.tab = 0;
      this.$refs.addSpeakerForm.reset();
      this.$emit("close");
    },
    async handleAddSpeaker(isAddAnother) {
      let isValid = this.$refs.addSpeakerForm.validate();
      if (isValid) {
        if (this.tab == 0) {
          this.tab = 1;
          return;
        }
        let snackbarText = "";
        try {
          this.loading = true;
          const speakerId = await this.currentSpeaker.save();
          this.currentSpeaker.speakerId = speakerId;
          console.log("Current Speaker", this.currentSpeaker);
          let invitee = new Attendee({
            email: this.currentSpeaker.email,
            firstName: this.currentSpeaker.firstName,
            lastName: this.currentSpeaker.lastName,
            attendeeId: uuid.v4(),
            invitedAt: new Date(),
            associatedSpeakerSessions: [this.currentSession.id],
            associatedSubEvents: [this.currentSubEvent.id],
            uid: uuid.v4(),
            accessToken: uuid.v4(),
            speakerId: speakerId,
          });

          await invitee.generatePrivateLink(
              this.currentEvent.id,
              this.currentEvent.name
          );

          //Push or update the speaker in the event

          this.currentEvent.speakers.push(this.currentSpeaker);

          this.sendInvitationEmail(invitee);


          //Save
          await this.currentEvent.save();

          //Hide loading dialog
          this.loading = false;
          if (!isAddAnother) {
            this.$emit("added");
          }

          //Reset the form
          this.tab = 0;
          this.$nextTick(function () {
            this.$refs.addSpeakerForm.reset();
          });

          if (isAddAnother) {
            this.currentSpeaker = new Speaker({
              associatedSpeakerSessions: this.currentSpeaker.associatedSpeakerSessions,
              speakerRelations: this.currentSpeaker.speakerRelations,
            });
          } else {
            this.currentSpeaker = {};
          }

          //Show the snackbar
          snackbarText = "Speaker Saved successfully!";


          //Start: Show invitee in the data-table
          // this.initializeSessionSpeakerDetails();
          //End: Show invitee in the data-table
        } catch (error) {
          console.log("Error occurred while adding speaker: ", error);
          snackbarText = "Error occurred, please try again!";
        }
        this.showSnackbar({show: true, text: snackbarText});
      } else if (this.currentSpeaker.displayImageURL == "") {
        this.showDisplayImageURLValidationError = true;
      } else {
        console.log("form is invalid");
        this.showDisplayImageURLValidationError = false;
      }
    },
    isValid(value) {
      return value != undefined && value != "";
    },
    async sendInvitationEmail(invitee) {
      let invitationLink = "";

      invitationLink = invitee.dynamicLink;

      let result = await invitee.sendInvitation(
          this.currentEvent.linkPrivacy,
          invitationLink,
          this.currentEvent.name,
          invitee.firstName,
          invitee.lastName,
          this.currentEvent.hostName
      );
      console.log(result);
      return result.data.success;
    },
  },
  data() {
    return {
      requiredSocialRules: [(v) => v === '' || !!v || "This field is required"],
      dropzoneOptions: {
        autoProcessQueue: false,
        url: "http://localhost",
        previewsContainer: false,
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        acceptedFiles: ".jpg, .jpeg, .png",
      },
      requiredRules: [(v) => !!v || "This field is required"],
      refreshCropper: 0,

      dialogTitle: "Add a Speaker",
      selectedImage: "",
      isFormValid: false,
      showDisplayImageURLValidationError: false,
      tab: 0,
      isSaveSpeakerEnabled: true,
      currentSpeaker: null,
      loading: false
    }
  },
  props: {
    speaker: {},
    isEdit: {
      type: Boolean,
      default: false
    },
  },
  created() {
    this.tab = 0;
    this.currentSpeaker = this.speaker;
  },
  computed: {
    urlPrefixes() {
      return urlPrefixes
    },
    ...mapGetters([
      "selectedBusinessProfileId",
      "businessProfile",
      "currentSubEvent",
      "currentEvent",
      "userProfile",
      "currentSession",
      "urlPrefixes"
    ]),
    saveSpeakerBtnText() {
      if (this.tab == 0) {
        return "Next";
      } else {
        return "Done";
      }
    },
    isButtonEnabled() {
      if (this.tab == 0) {
        return this.isValid(this.currentSpeaker.displayImageURL) && this.isValid(this.currentSpeaker.firstName) && this.isValid(this.currentSpeaker.lastName) && this.isValid(this.currentSpeaker.jobTitle) && this.isValid(this.currentSpeaker.businessName) && this.isValid(this.currentSpeaker.email) && this.isValid(this.currentSpeaker.bio);
      }
      return true;
    }
  }
}
</script>
<style>
.circle {
  border-radius: 50%;
  position: relative;
}

.cursor-pointer {
  cursor: pointer !important;
}

.outlined-border {
  border: 1px solid #e0e0e0;
}

.circular-dropzone-border {
  background-color: white !important;
  border: 3px dashed #5160774d !important;
}
</style>